import $ from 'jquery'
import { Alert } from '../functions'
import * as FilePond from 'filepond'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import fr_fr from 'filepond/locale/fr-fr.js';

FilePond.setOptions(fr_fr);
FilePond.registerPlugin(FilePondPluginFileValidateType);

const object = gralObject;

const pondCvRc = FilePond.create(document.querySelector('.filepond-cv-rc'), {
    fileValidateTypeLabelExpectedTypes: 'Expects {allButLastType} or {lastType}',
});

const pondCoverLetterRc = FilePond.create(document.querySelector('.filepond-cover-letter-rc'), {
    fileValidateTypeLabelExpectedTypes: 'Expects {allButLastType} or {lastType}',
});

const fileErrorCv = $('#js-filepond-cv-rc-error-container');
pondCvRc.on('addfile', (event) => {
    fileErrorCv.html('')
});

pondCvRc.on('removefile', (event) => {
    fileErrorCv.html(fileErrorCv.attr('data-error-message'))
});

const fileErrorCoverLetter = $('#js-filepond-cover-letter-rc-error-container');
pondCoverLetterRc.on('addfile', (event) => {
    fileErrorCoverLetter.html('')
});

pondCoverLetterRc.on('removefile', (event) => {
    fileErrorCoverLetter.html(fileErrorCoverLetter.attr('data-error-message'))
});

let recruitmentsForm = $('.recruitments-form')
recruitmentsForm.parsley()

recruitmentsForm.on('submit', function (e) {

    e.preventDefault()
    e.stopPropagation()
    e.stopImmediatePropagation()

    const $form = $(this)

    const formData = new FormData($(this)[0])
    formData.append('action', 'vn_recruitments_form')

    var pondCvRcFiles = pondCvRc.getFiles();
    formData.append('cv', pondCvRcFiles[0].file);

    var pondCoverLetterRcFiles = pondCoverLetterRc.getFiles();
    if (pondCoverLetterRcFiles.length > 0 ) {
        formData.append('cover_letter', pondCoverLetterRcFiles[0].file);
    }

    $.ajax({
        url: object.ajaxUrl,
        type: 'POST',
        dataType: 'JSON',
        data: formData,
        processData: false,
        contentType: false,
        beforeSend: () => {
            $form.addClass('sending')
            Alert('warning', object.formWait, false)
        },
        success: (res) => {
            $form.removeClass('sending')

           if (res.success && res.data.redirect) {
                window.location = res.data.redirect
            }

            if (!res.success) {
                Alert(res.success, res.data.message)
            }
        },
    })

})
